<template>
  <div class="row">
            <div class="col-md-12">
                <div class="panel panel-default form-group">
                    <div class="panel-heading"><i class="fa fa-fw fa-pencil-square-o"></i> Private Comments </div>
                    <div class="panel-body"><textarea class="full-width full-height"></textarea></div>
                </div>
            </div>
        </div>
</template>